import ComplexProjectViewer from '../../components/complex-project-viewer/complex-project-viewer.vue';
export default {
	components: {
		'complexProjectViewer': ComplexProjectViewer,
	},
  props: [
    'incognitoMode',
  ],
  data () {
    return {
      name: 'ESPC',
      incognitoName: 'Property market app',
      bgColor: '#0293e8',//032c5a
      platforms: [
        {
          deviceName: 'iPhone7 prototype',
          tabName: 'Prototyping',
          screens: [
            { image: 'https://palmaka.design/folio-db/projects/espc/prototype/1.mp4'},
          ],
        },
        {
          deviceName: 'iPhone7',
          tabName: 'iPhone',
          screens: [
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-1@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-2@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-3@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-4@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-5@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-6@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-7@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-8@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-9@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-10@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-11@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-12@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-13@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-14@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-15@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-16@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-17@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-18@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-19@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-20@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-21@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-22@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-23@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-24@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-25@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-26@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-27@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-28@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-29@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-30@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-31@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-32@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-33@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-34@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-35@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-36@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-37@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-38@2x.png'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-iphone/img-39@2x.jpg'},
          ],
        },
        {
          deviceName: 'googlePixel',
          tabName: 'Android',
          screens: [
            { image: 'https://palmaka.design/folio-db/projects/espc/android-phone/img-1@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-phone/img-2@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-phone/img-3@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-phone/img-4@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-phone/img-5@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-phone/img-6@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-phone/img-7@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-phone/img-8@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-phone/img-9@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-phone/img-10@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-phone/img-11@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-phone/img-12@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-phone/img-13@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-phone/img-14@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-phone/img-15@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-phone/img-16@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-phone/img-17@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-phone/img-18@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-phone/img-19@2x.jpg'},
          ],
        },
        {
          deviceName: 'iPad',
          tabName: 'iPad',
          screens: [
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-ipad/img-1@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-ipad/img-2@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-ipad/img-3@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-ipad/img-4@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-ipad/img-5@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-ipad/img-6@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-ipad/img-7@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-ipad/img-8@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-ipad/img-9@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-ipad/img-10@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-ipad/img-11@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-ipad/img-12@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/ios-ipad/img-13@2x.jpg'},
          ],
        },
        {
          deviceName: 'nexus7',
          tabName: 'Android tablet',
          screens: [
            { image: 'https://palmaka.design/folio-db/projects/espc/android-tablet/img-2@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-tablet/img-3@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-tablet/img-4@2x.png'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-tablet/img-5@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-tablet/img-6@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-tablet/img-7@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-tablet/img-8@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-tablet/img-9@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-tablet/img-10@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-tablet/img-11@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-tablet/img-12@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-tablet/img-13@2x.jpg'},
            { image: 'https://palmaka.design/folio-db/projects/espc/android-tablet/img-14@2x.jpg'},
          ],
        },
      ],
    };
  },
}